export default __webpack_public_path__ + "static/media/cm.682aa075.svg";